import axios from 'axios'
import { PRODUCT_URL } from './api'
import { authorizationHelper } from '../common/helpers'

function createFormData(imgV, imgH, body) {
    const data = new FormData();

    if (imgV) data.append('photos', imgV, 'vertical_img')
    if (imgH) data.append('photos', imgH, 'horizontal_img')

    Object.keys(body).forEach(key => {
        data.append(key, body[key]);
    });

    return data;
};

export function getAll(page, filter, categoryId) {

    const params = {
        page,
        filter,
        category_id: categoryId
    }

    return axios.get(PRODUCT_URL, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function get(id) {
    const url = `${PRODUCT_URL}/${id}`

    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getProductStores(id) {
    const url = `${PRODUCT_URL}/stockProductStores/${id}`
    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function putStockProductStores(id, minStock, store_id) {
    const url = `${PRODUCT_URL}/stockProductStores/${id}`

    const params = {
        minStock,
        store_id,
    }
    return axios.put(url, params, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function create(product, imgV, imgH) {
    return axios.post(
        PRODUCT_URL,
        createFormData(imgV, imgH, product),
        { headers: { 'Authorization': authorizationHelper.getAuthorizationToken() } }
    )
}

export function update(id, product, imgV, imgH) {
    const url = `${PRODUCT_URL}/${id}`

    return axios.put(url,
        createFormData(imgV, imgH, product),
        { headers: { 'Authorization': authorizationHelper.getAuthorizationToken() } }
    )
}

export function deleteProduct(id) {
    const url = `${PRODUCT_URL}/${id}`

    return axios.delete(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getOrders(id, page) {
    const url = `${PRODUCT_URL}/${id}/orders`

    const params = {
        page
    }

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function deleteProductOrder(id) {
    const url = `${PRODUCT_URL}/${id}/orders`
    return axios.delete(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function createOrder(id, order) {
    const url = `${PRODUCT_URL}/${id}/orders`

    return axios.post(url, order, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}


// WEBPACK FOOTER //
// ./src/service/product.js